import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSwitch } from './input-switch/input-switch';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    InputSwitch
  ],
  imports: [
    CommonModule,
    ToggleSwitchModule,
    FormsModule,
  ],
  exports: [
    InputSwitch,
  ]
})
export class InputSwitchModule { }
